<template>
    <div class="filtros-main">
        <!-- Filtros -->
        <b-collapse class="card" :open="false">
            <div slot="trigger" slot-scope="props" class="card-header is-paddingless">
                <div class="card-header-title">
                    <div class="filtro-header">
                        <b-icon :icon="props.open ? 'menu-down' : 'menu-right'"></b-icon>
                        {{ $t('filtros') }}
                        <span class="tag">{{ qtdFiltros }}</span>
                    </div>
                </div>
            </div>
            <div class="card-content" v-show="estados.allowButtons">
                <div class="columns is-multiline">
                    <div class="column is-full card-content-top">
                        <div class="columns is-1 is-variable">
                            <div class="column is-hidden-mobile is-half-touch-only"></div>
                            <div
                                class="column is-full-mobile is-one-third-desktop is-one-fourth-widescreen is-one-fifth-fullhd"
                            >
                                <label v-text="$t('add-filtro')" />
                                <v-select
                                    ref="selectAddFiltro"
                                    class="no-clear smaller"
                                    :options="filtrosDisponiveis"
                                    @input="addFilter"
                                >
                                    <template slot="option" slot-scope="option">{{
                                        $t(option.label)
                                    }}</template>
                                    <template slot="no-options">{{
                                        $t('sem-resultados')
                                    }}</template>
                                </v-select>
                            </div>
                        </div>
                    </div>
                    <div
                        class="column is-full filter-items"
                        v-for="(f, i) in filtrosAtuais"
                        :key="i"
                    >
                        <div
                            class="columns is-vcentered is-1 is-variable is-multiline is-mobile"
                            :class="{
                                'not-date': f.type != 'date' && f.selected,
                            }"
                        >
                            <!-- Label do Filtro -->
                            <div
                                class="column is-half-mobile is-flex filter-label"
                                :class="{
                                    'is-one-third-desktop is-full-mobile':
                                        f.type != 'date' && showOptions,
                                    'is-two-thirds-desktop is-half-mobile':
                                        f.type == 'date' || (f.type != 'date' && !showOptions),
                                }"
                            >
                                <label class="check-box" :for="f.label" v-if="!f.required">
                                    <input type="checkbox" :id="f.label" v-model="f.selected" />
                                    <span class="checkmark" />
                                </label>
                                <div class="filter-label-text">
                                    {{ $t(f.label) }}
                                </div>
                            </div>

                            <!-- Modificador -->
                            <div
                                class="column is-half-mobile is-one-fifth-desktop"
                                v-if="f.type != 'date' && showOptions"
                            >
                                <v-select
                                    ref="selectModifier"
                                    class="no-clear smaller"
                                    v-if="f.selected && f.searchModifiers.length > 1"
                                    :searchable="false"
                                    v-model="f.modifierValue"
                                    :options="f.searchModifiers"
                                    :getOptionLabel="getLabel"
                                >
                                    <template slot="option" slot-scope="option">{{
                                        $t(option.label)
                                    }}</template>
                                    <template slot="no-options">{{
                                        $t('sem-resultados')
                                    }}</template>
                                </v-select>
                            </div>

                            <!-- Selecionar Valores -->
                            <div
                                v-if="f.selected"
                                class="column"
                                :class="{
                                    'is-full-touch': f.type != 'date',
                                    'is-half-touch': f.type == 'date',
                                }"
                            >
                                <v-select
                                    :ref="'selectFilterOption-' + f.label"
                                    class="no-clear smaller"
                                    v-if="f.selected && f.type == 'select'"
                                    :options="f.options"
                                    @search="loadSearch(f)"
                                    :loading="f.loading"
                                    :multiple="f.multiple"
                                    v-model="f.selectedValue"
                                >
                                    <template slot="no-options">{{
                                        $t('sem-resultados-filtro')
                                    }}</template>
                                </v-select>
                                <input
                                    :ref="'inputFilterOption-' + f.label"
                                    v-model="f.selectedValue"
                                    v-if="f.selected && f.type == 'input'"
                                    style="height: 25px; color: #666666"
                                />
                                <verified-date-picker
                                    :ref="'dateFilterOption-' + f.label"
                                    dateType="startDate"
                                    v-if="f.selected && f.type == 'date' && f.label == 'inicio'"
                                    v-model="datainicial"
                                    :endDate="datafinal"
                                    title=""
                                    @input="changeStartDate"
                                    :inForm="true"
                                />
                                <verified-date-picker
                                    :ref="'dateFilterOption-' + f.label"
                                    v-if="f.selected && f.type == 'date' && f.label == 'fim'"
                                    dateType="endDate"
                                    v-model="datafinal"
                                    title=""
                                    :startDate="datainicial"
                                    @input="changeEndDate"
                                    :inForm="true"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-collapse>

        <!-- Opções -->
        <b-collapse class="card" :open="false" v-if="showOptions">
            <div slot="trigger" slot-scope="props" class="card-header is-paddingless">
                <div class="card-header-title">
                    <div class="filtro-header">
                        <b-icon :icon="props.open ? 'menu-down' : 'menu-right'"></b-icon>
                        {{ $t('opcoes') }}
                    </div>
                </div>
            </div>
            <div class="card-content" v-show="estados.allowButtons">
                <div class="columns is-multiline">
                    <div class="column is-half is-full-mobile card-content-top">
                        <label v-text="$t('col-disponivel')" />
                        <div
                            class="cols-container"
                            v-if="colsDisponiveis.length > 0 || colsSelecionadas.length > 0"
                        >
                            <v-draggable
                                class="drag-area"
                                :list="colsDisponiveis"
                                :options="{ sort: false, group: 'cols' }"
                            >
                                <div class="cols-item" v-for="(c, i) in colsDisponiveis" :key="i">
                                    <span>{{ $t(c) }}</span>
                                    <button class="btn" @click="addCol(i)">
                                        <b-icon icon="plus" size="is-small" />
                                    </button>
                                </div>
                            </v-draggable>
                        </div>
                    </div>
                    <div class="column is-half is-full-mobile card-content-top">
                        <label v-text="$t('col-selecionadas')" />
                        <div
                            class="cols-container"
                            v-if="colsDisponiveis.length > 0 || colsSelecionadas.length > 0"
                        >
                            <v-draggable
                                class="drag-area"
                                :list="colsSelecionadas"
                                :options="{ group: 'cols' }"
                                :move="moveCallback"
                            >
                                <div class="cols-item" v-for="(c, i) in colsSelecionadas" :key="i">
                                    <span>{{ $t(c) }}</span>
                                    <button class="btn" @click="removeCol(i)">
                                        <b-icon icon="minus" size="is-small" />
                                    </button>
                                </div>
                            </v-draggable>
                        </div>
                    </div>
                    <div
                        class="column is-half is-full-mobile is-one-third-widescreen card-content-top"
                    >
                        <label v-text="$t('agrupar-por')" />
                        <v-select
                            ref="selectAgruparPor"
                            class="smaller"
                            v-model="agrupar"
                            :options="allColunas"
                            :getOptionLabel="getLabel"
                        >
                            <template slot="no-options">{{ $t('sem-resultados') }}</template>
                        </v-select>
                    </div>
                </div>
            </div>
        </b-collapse>

        <!-- Botões -->
        <div class="columns mt-0 mb-2">
            <div class="column is-4 has-text-centered">
                <button
                    class="save-btn pl-4 pr-4"
                    @click="aplicarDados"
                    :class="{
                        disabled: estados.isSearching || !estados.allowButtons,
                    }"
                >
                    {{ $t('pesquisar') }}
                </button>
            </div>
            <div class="column is-4 has-text-centered">
                <button
                    class="delete-btn pl-4 pr-4"
                    @click="confirmCleanFilters"
                    :class="{ disabled: !estados.allowButtons }"
                >
                    {{ $t('limpar-filtros') }}
                </button>
            </div>
            <div class="column is-4 has-text-centered">
                <svg class="svg-loader dark" v-if="estados.isExporting">
                    <use :xlink:href="require('@/assets/img/icons/loader.svg') + '#layer'"></use>
                </svg>
                <button
                    class="delete-btn pl-4 pr-4"
                    v-if="permissao.export"
                    @click="exportar"
                    :class="{
                        disabled: estados.isExporting || !estados.allowButtons,
                    }"
                >
                    {{ $t('exportar-rel') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        isOpen: {
            type: Boolean,
            default: false,
        },
        showOptions: {
            type: Boolean,
            default: true,
        },
        allColunas: {
            type: Array,
            default: function () {
                return [];
            },
        },
        colsSelecionadas: {
            type: Array,
            default: function () {
                return [];
            },
        },
        filters: {
            type: Array,
            default: [],
        },
        filtrosAtuais: {
            type: Array,
            default: [],
        },
        // Função que traz os dados e opções do filtro
        getFiltro: {
            type: Function,
            default: function (id) {
                return null;
            },
        },
        estados: {
            type: Object,
            default: {
                isSearching: false,
                isExporting: false,
                allowButtons: true,
            },
        },
        permissao: {
            default: {
                export: true,
            },
        },
    },
    data() {
        return {
            filtrosDisponiveis: [],
            agrupar: null,
            colsDisponiveis: [],
            datainicial: null,
            datafinal: null,
        };
    },
    created() {
        this.colsDisponiveis = [...this.allColunas];
        this.filtrosDisponiveis = [...this.filters];
        this.datainicial = this.$moment(this.filtrosAtuais[0].selectedValue, 'DD/MM/YYYY').toDate();
        this.datafinal = this.$moment(this.filtrosAtuais[1].selectedValue, 'DD/MM/YYYY').toDate();

        this.aplicarDados();
    },
    methods: {
        mountColumns() {
            if (this.colsDisponiveis.length > 0) {
                if (this.colsSelecionadas.length == 0) {
                    this.addCol(0);
                } else {
                    this.colsSelecionadas.forEach((c) => {
                        let index = this.colsDisponiveis.findIndex((e) => {
                            return c == e;
                        });

                        if (index > -1) {
                            this.colsDisponiveis.splice(index, 1);
                        }
                    });
                    this.sortDisponiveis(this.colsSelecionadas);
                }
            }
        },
        getLabel(option) {
            if (option.label != undefined) {
                return this.$t(option.label);
            } else {
                return this.$t(option);
            }
        },
        moveCallback() {
            if (this.colsSelecionadas.length <= 1) {
                return false;
            }
        },
        addFilter(f) {
            if (f != null) {
                let nome = f.label != undefined ? f.label : f.nome;

                if (this.$refs.selectAddFiltro != undefined) {
                    this.$refs.selectAddFiltro.clearSelection();
                }

                let index = this.filtrosDisponiveis.findIndex((e) => {
                    return nome == e.label;
                });

                let filtro = this.getFiltro(f);
                if (filtro && filtro != null && filtro != undefined) {
                    this.loadSearch(filtro);

                    /**
                     * @84346 - fazer validacao dos ids do filtro somente na inicializacao do mesmo, durante as buscas
                     * estava gerando problemas no componente
                     */
                    if (filtro.ids != undefined) {
                        filtro.selectedValue = [];

                        filtro.ids.forEach((i) => {
                            filtro.searchFunction(i, true).then((r) => {
                                filtro.selectedValue.push(r);
                            });
                        });
                    }

                    filtro.selected = true;
                    filtro.required = false;
                    filtro.label = nome;
                    f.loading = true;

                    if (filtro.modifierValue == null || filtro.modifierValue == undefined) {
                        filtro.modifierValue = filtro.searchModifiers[0];
                    }

                    let idx = this.filtrosAtuais.findIndex((f) => {
                        return nome == f.label;
                    });

                    // Prevenção de inclusão duplicada
                    if (idx < 0) {
                        this.filtrosAtuais.push(filtro);
                        this.filtrosDisponiveis.splice(index, 1);
                    }
                }
            }
        },
        removeCol(i) {
            if (this.colsSelecionadas.length > 1) {
                var removed;
                removed = this.colsSelecionadas.splice(i, 1);
                this.colsDisponiveis.unshift(removed[0]);
            }
        },
        addCol(i) {
            var added;
            added = this.colsDisponiveis.splice(i, 1);
            this.colsSelecionadas.push(added[0]);
        },
        aplicarDados() {
            this.filtrosAtuais.forEach((f) => {
                if (!f.selected) {
                    this.filtrosDisponiveis.unshift({ label: f.label });
                }
            });

            this.$emit('aplicar-filtro', {
                filtros: this.filtrosAtuais.filter(this.filterSelected),
                agrupar: this.agrupar,
            });
        },
        exportar() {
            this.$emit('exportar', {
                filtros: this.filtrosAtuais.filter(this.filterSelected),
                agrupar: this.agrupar,
            });
        },
        filterSelected(f) {
            return f.selected;
        },
        confirmCleanFilters() {
            this.$root.confirm({
                message: this.$t('msg-confirm-limpar-filtros'),
                onConfirm: this.limparFiltros,
            });
        },
        limparFiltros() {
            this.filtrosDisponiveis = [...this.filters];

            this.$emit('clean');
        },
        loadSearch(f) {
            let value = this.$refs['selectFilterOption-' + f.label]
                ? this.$refs['selectFilterOption-' + f.label][0].search
                : '';

            f.loading = true;

            f.searchFunction(value).then((itens) => {
                f.options = itens.sort();
                f.loading = false;
            }, 350);
        },
        setAgrupamento(value) {
            this.agrupar = value;
        },
        sortDisponiveis(c) {
            /* Ordenar as colunas disponíveis na mesma ordem das selecionadas */
            this.allColunas.sort(function (a, b) {
                var ia = c.findIndex((e) => {
                    return e == a;
                });
                var ib = c.findIndex((e) => {
                    return e == b;
                });

                if (ia >= 0 && ib >= 0) {
                    return ia - ib;
                } else {
                    if (ia == ib) return 0;
                    if (ia < 0) return 1;
                    if (ib < 0) return -1;
                }
            });
        },
        changeStartDate(date) {
            if (date != null) {
                this.datainicial = date;
                this.filtrosAtuais[0].selectedValue = this.$moment(date).format('DD/MM/YYYY');
            }
        },
        changeEndDate(date) {
            if (date != null) {
                this.datafinal = date;
                this.filtrosAtuais[1].selectedValue = this.$moment(date).format('DD/MM/YYYY');
            }
        },
    },
    computed: {
        qtdFiltros: function () {
            let q = 0;
            this.filtrosAtuais.forEach((f) => {
                if (f.selected) q++;
            });
            return q;
        },
    },
    watch: {
        colsSelecionadas(c) {
            this.sortDisponiveis(this.colsSelecionadas);
        },
    },
};
</script>

<style lang="scss" scoped>
.filtros-main {
    font-size: 12px;
}

label {
    font-size: 10px;
    margin-bottom: 0;
}

a {
    padding-left: 5px;

    &.disabled {
        color: #666;
        cursor: not-allowed;
        pointer-events: none;
    }
}

.check-box .checkmark {
    top: -1px !important;
}

.svg-icons {
    width: 20px;
    height: 20px;
}

.card {
    color: $darker-gray-color;

    .card-header-title {
        color: $darker-gray-color;
        justify-content: space-between;
        padding: 0.3rem;
    }

    .card-content {
        padding: 0.9rem;

        .card-content-top {
            padding-top: 0.25rem;
            padding-bottom: 0.25rem;
        }
    }
}

.filtro-header {
    display: flex;
    align-items: center;
}

.check-box {
    .checkmark {
        position: inherit;
        display: inline-flex;
        top: 0;
        right: 0;
        height: 16px;
        width: 16px;
        border: 2px solid $primary-color-hover;
        margin-top: 5px;
        border-radius: 3px;
    }
}

.filter-items {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;

    @media screen and (max-width: 1088px) {
        .not-date > .column {
            &:not(:last-child) {
                padding-bottom: 0;
            }

            &:last-child {
                padding-top: 0.5rem;
            }
        }
    }

    .filter-label {
        align-items: center;

        label {
            padding-right: 5px;
        }

        &-text {
            display: flex;
            height: 28px;
            align-items: center;
        }
    }
}

.cols-container {
    border: 1px solid $table-border;
    border-radius: 2px;
    height: 200px;
    overflow-y: scroll;

    .cols-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0.5rem;
        border-bottom: 1px solid $table-border;
        cursor: move;

        .btn {
            padding: 0;
            height: 20px;
            line-height: 1.2;
        }
    }

    .drag-area {
        height: 198px;
    }
}

div.collapse.card {
    overflow: visible !important;
}

.tag {
    background-color: $primary-color;
    color: $sovis-white;
    margin-left: 10px;
    font-size: 10px;
}
</style>
